import KunLoading99 from './src/index'

KunLoading99.install = function (Vue) {
	Vue.component(KunLoading99.name, KunLoading99);
}

export default KunLoading99;
